import React from 'react';
import styles from './AboutUsHero.module.scss';

const AboutUsHero = () => {
    return (
        <section className={styles.heroSection}>
            <div className={styles.glow}></div>
            <div className={styles.contentWrapper}>
                <h1 className={styles.title}>We didn't just build an app.</h1>
                <h1 className={styles.titleAccent}>We lived the struggle.</h1>
                <p className={styles.subtitle}>
                    Prepal was born from a pattern we saw in hundreds of students: hard work wasted on
                    rigid systems that don't adapt to how they actually learn.
                </p>
            </div>
        </section>
    );
};

export default AboutUsHero;
